import React, { useCallback, useState } from 'react';

// Components
import { WpModal, WpModalBody, WpModalFooter, WpModalHeader } from 'Wpds/components/modal';
import WpButton from 'Wpds/components/button/WpButton';
import TemplateGallery from 'Shared/components/TemplateGallery/TemplateGallery';

import './TemplateGalleryModal.scss';

type Props = {
  isGroup: boolean;
  onToggle(): void;
  onCreateTemplate: Function;
};

function TemplateGalleryModal({ isGroup, onToggle, onCreateTemplate }: Props) {
  const [startWithRecommendedTemp, setStartWithRecommendedTemp] = useState(false);

  const handlePreviewTemplateClose = useCallback(() => {
    if (onToggle) onToggle();
  }, [onToggle]);

  const handlePreviewTemplateBack = useCallback(() => setStartWithRecommendedTemp(false), []);

  return (
    <WpModal isOpen onToggle={onToggle} size="md">
      <WpModalHeader>Template Gallery</WpModalHeader>
      <WpModalBody>
        <div className="TemplateGalleryModal">
          {!startWithRecommendedTemp && <div className="mb-4">Start setting up your workspace with a template</div>}
          <TemplateGallery
            isGroup={isGroup}
            onSubmit={onToggle}
            ovPreviewTemplateClose={handlePreviewTemplateClose}
            useTwoColumns
            startWithRecommendedTemp={startWithRecommendedTemp}
            onPreviewTemplateBack={handlePreviewTemplateBack}
            onCreateTemplate={onCreateTemplate}
          />
        </div>
      </WpModalBody>
      <WpModalFooter>
        <WpButton variant="tertiary" onClick={onToggle}>
          Cancel
        </WpButton>
      </WpModalFooter>
    </WpModal>
  );
}

export default TemplateGalleryModal;
